import Vue from 'vue';
import _ from "lodash";

Number.prototype.toRound = function() {
    return Math.round(this * 100) / 100;
}



Date.prototype.toUTC = function(){
    return this.getTime() + this.getTimezoneOffset()*60*1000;
    //return new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds()));
}


_.mixin({
    'mergeByKey': function(arr1, arr2, key) {
        console.log("MERGIN!")
        var criteria = {};
        criteria[key] = null;
        return _.map(arr1, function(item) {
            criteria[key] = item[key];
            return _.merge(item, _.find(arr2, criteria));
        });
    }
});